import React, { useContext } from 'react';
import { Bar } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext'; // Adjust the import path as needed
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const DivisionRevenueChart = () => {
  const { netRevenue, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!netRevenue) {
    return <div>No net revenue data available</div>;
  }

  // Filter and aggregate data
  const grossData = netRevenue.filter(item => item.Agrupacion === "GROSS");
  const divisionTotals = grossData.reduce((acc, item) => {
    const divisionName = item.DivisionNombre;
    const haberAmount = parseFloat(item.Haber);

    if (!acc[divisionName]) {
      acc[divisionName] = 0;
    }

    acc[divisionName] += haberAmount;
    return acc;
  }, {});

  // Prepare chart data
  const chartData = {
    labels: Object.keys(divisionTotals),
    datasets: [
      {
        label: 'Total Haber by Division',
        data: Object.values(divisionTotals),
        backgroundColor: '#4B77BE',
        hoverBackgroundColor: '#354A5F',
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800">Division Revenue</h2>
      </div>
      <div className="h-64">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default DivisionRevenueChart;
